import '../../assets/tailwind-compiled.css';
import '../register/RegisterComponent.css';

import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useState} from 'react';

import {mainState} from '../../AppMainState';
import logoDark from '../../assets/images/logo_dark.svg';
import {Card} from '../../components/Card';
import {ResetPasswordState} from './ResetPasswordState';
import {LinkButton} from '../../components/LinkButton';
import {AppRoutes} from '../../routing/AppRoutes';

export const ResetPasswordComponent: FC = observer(
    () => {
        const [state] = useState(() => new ResetPasswordState());

        return <div
            id="login-wrapper"
            className="h-screen max-h-screen blur-overlay flex h-full items-center justify-center px-6 py-5 w-full lg:px-10 lg:py-8"
        >
            <Card footer={
                <div className="flex justify-between">
                    <LinkButton to={AppRoutes.Login}>Back to logging in</LinkButton>
                    <LinkButton to="https://www.muscula.com/prices/">Show all plans</LinkButton>
                </div>
            }>
                <div className="flex justify-center py-6">
                    <img
                        className="w-56"
                        src={logoDark}
                        alt="Muscula logo"
                    />
                </div>

                <h2 className="mb-6 text-m-green">Reset password for {state.email}</h2>
                <form onSubmit={(e) => {
                    e.preventDefault();
                }}>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            onChange={(e) => state?.setPassword(e.target.value)}
                            className={'form-control' + (state.invalidData ? ' is-invalid' : '')} />
                        {state.invalidData && <div className="invalid-feedback">
                            {state.password.length===0 && <div>
                                Password is required
                            </div>}
                            {state.password.length < 12 && <div>
                                Password must be at least 12 characters
                            </div>}
                        </div>}
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            onChange={(e) => state?.setConfirmPassword(e.target.value)}
                            className={'form-control' + (state.invalidData ? ' is-invalid' : '')} />
                        {state.invalidData &&
                            <div className="invalid-feedback">
                                {state.password!==state.confirmPassword && <div>
                                    Password's doesn't match
                                </div>}
                            </div>}
                    </div>

                    <div className="flex form-group items-center justify-between">
                        <button
                            onClick={() => state?.resetPassword()}
                            className="btn btn-primary w-full"
                            disabled={mainState.isLoading}
                            type="submit"
                        >
                            {mainState.isLoading && <span className="spinner-border spinner-border-sm mr-1" />}
                            Reset password
                        </button>
                    </div>
                </form>
            </Card>
        </div>;
    },
);
